import React from 'react';
import { Paper } from '@material-ui/core';
import TabHeader from './TabHeader';
import TabBody from './TabBody';

function Search(props) {
    const { values, tabChange, checkboxHandleChange, setChartVisibleStyle } = props;
    return (
        <div className="search-root">
            <Paper elevation={0} className="search-description">～下記より検索条件を変更できます～</Paper>
            <TabHeader values={values} tabChange={tabChange} setChartVisibleStyle={setChartVisibleStyle} />
            <TabBody values={values} checkboxHandleChange={checkboxHandleChange} setChartVisibleStyle={setChartVisibleStyle} />
        </div>
    )
}

export default Search;
